import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'assets/theme';
import React, { useEffect } from 'react';

const CIQ = (window as any).CIQ;

interface ICrosshairsProps {
	ciq?: any,
	showCrosshairs: boolean,
	toggleCrosshairsAndSave: (ciq: any) => void
}

export const Crosshairs: React.FunctionComponent<ICrosshairsProps> = ({ciq, showCrosshairs, toggleCrosshairsAndSave}) => {
	useEffect(() => {
		if (ciq) {
			CIQ.ChartEngine.prototype.append('headsUpHR', () => null);
		}
	}, [ciq]);

	const toggleCrosshairsClickHandler = () => {
		toggleCrosshairsAndSave(ciq)
	}

	if (!ciq) {
		return <div />;
	}

	return (
			<CrosshairButton active={showCrosshairs} onClick={toggleCrosshairsClickHandler}>
				<FontAwesomeIcon style={{ cursor: 'pointer' }} size="1x" icon={faCrosshairs} />
			</CrosshairButton>
	);
};

const CrosshairButton = styled.button<{ active: boolean }>`
	height: 27px;
	width: 27px;
	opacity: .6;
	transition: opacity .20s 0s;
	border-width: 1px;
	border-color: ${({ theme }) => theme.core.textColor};
	border-style: ${({ active }) => active ? 'solid' : 'none'};
	:focus {
		border-color: ${({ theme }) => theme.core.textColor};
		border-style: ${({ active }) => active ? 'solid' : 'none'};
	}
`